import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
import createPlotlyComponent from 'react-plotly.js/factory';
import Plotly from 'plotly.js/dist/plotly.min';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';

import './style.css';
import { useState, useEffect } from 'react';

const Plot = createPlotlyComponent(Plotly);

function Pivottable(props) {
  const PlotlyRenderers = createPlotlyRenderers(Plot);
  const [state, setState] = useState(props);
  const [dadosPivottable, setDadosPivottable] = useState([]);
  const [view, setView] = useState(true);

  useEffect(() => {
    setView(false);
    setState(props);
    setDadosPivottable(props.data);
    setTimeout(() => setView(true), 300);
  }, [props, props.data]);

  return (
    <div>
      {view ? (
        <PivotTableUI
          data={dadosPivottable}
          renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
          onChange={(s) => {
            delete s.data;
            setState(s);
          }}
          {...state}
        />
      ) : (
        <h1>Carregando...</h1>
      )}
    </div>
  );
}

export default Pivottable;
